var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2 2.9L18 2.1C16.6 0.7 14.8 0 13 0C11.2 0 9.4 0.7 8 2.1L8.8 2.9C10 1.8 11.5 1.2 13 1.2C14.5 1.2 16 1.8 17.2 2.9ZM16.3 3.7C15.4 2.8 14.2 2.3 13 2.3C11.8 2.3 10.6 2.8 9.7 3.7L10.5 4.5C11.2 3.8 12.1 3.5 13 3.5C13.9 3.5 14.8 3.8 15.5 4.5L16.3 3.7ZM16 10H14V6H12V10H2C1.46957 10 0.960859 10.2107 0.585786 10.5858C0.210714 10.9609 0 11.4696 0 12V16C0 16.5304 0.210714 17.0391 0.585786 17.4142C0.960859 17.7893 1.46957 18 2 18H16C16.5304 18 17.0391 17.7893 17.4142 17.4142C17.7893 17.0391 18 16.5304 18 16V12C18 11.4696 17.7893 10.9609 17.4142 10.5858C17.0391 10.2107 16.5304 10 16 10ZM5 15H3V13H5V15ZM8.5 15H6.5V13H8.5V15ZM12 15H10V13H12V15Z",
    fill: "#848585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.cddc032a4f9a0333f1ac509e813e9e74.svg";
export { ForwardRef as ReactComponent };